export const websiteImages = [
  {
    fullUrl: 'public/website_ff_image1.png',
    thumbnailUrl: 'public/website_ff_thumb_image1.png',
    description: 'www.forwardfunds.com',
    waybackUrl:
      'https://web.archive.org/web/20110208072207/http://forwardfunds.com/',
  },
  {
    fullUrl: 'public/website_fm_image1.png',
    thumbnailUrl: 'public/website_fm_thumb_image1.png',
    description: 'www.forwardmgmt.com',
    waybackUrl:
      'https://web.archive.org/web/20110808024659/http://www.forwardmgmt.com/',
  },
  {
    fullUrl: 'public/website_image3.png',
    thumbnailUrl: 'public/website_thumb_image3.png',
    description: 'www.equalrights.org',
    waybackUrl:
      'https://web.archive.org/web/20060304133555/http://www.equalrights.org/',
  },
  {
    fullUrl: 'public/website_image4.png',
    thumbnailUrl: 'public/website_thumb_image4.png',
    description: 'www.childrenslearningctr.com',
    waybackUrl:
      'https://web.archive.org/web/20070311105104/https://www.childrenslearningctr.com/',
  },
  {
    fullUrl: 'public/website_image5.jpg',
    thumbnailUrl: 'public/website_thumb_image5.jpg',
    description: 'www.sierraclubfunds.com',
    waybackUrl:
      'https://web.archive.org/web/20080509054827/http://sierraclubfunds.com/',
  },
  {
    fullUrl: 'public/website_reflow_image1.png',
    thumbnailUrl: 'public/website_reflow_thumb_image1.png',
    description: 'www.reflow.com',
    waybackUrl: 'https://web.archive.org/web/20110202151804/http://reflow.com/',
  },
];
